import React from "react";
import { Link } from "react-router-dom";

import OurStore from "../../../user/our-store";
function OurStoreDetails(){
    return(
        <>
                {/* <!-- Our Store --> */}
        <section class="flat-spacing-16">
            <div class="container">
                <div class="tf-grid-layout md-col-2">
                    <div class="tf-ourstore-img">
                        <img class="lazyload" data-src="/assets/images/shop/store/ourstore2.png" src="/assets/images/shop/store/ourstore2.png" alt="our-store"/>
                    </div>
                    <div class="tf-ourstore-content">
                        <h5 class="mb_24">Ecomus Paris</h5>
                        <div class="mb_20">
                            <p class="mb_15"><strong>Address</strong></p>
                            <p>66 Mott St, New York, New York, Zip Code: 10006, AS</p>
                        </div>
                        <div class="mb_20">
                            <p class="mb_15"><strong>Phone</strong></p>
                            <p>(623) 934-2400</p>
                        </div>
                        <div class="mb_20">
                            <p class="mb_15"><strong>Email</strong></p>
                            <p>EComposer@example.com</p>
                        </div>
                        <div class="mb_36">
                            <p class="mb_15"><strong>Open Time</strong></p>
                            <p class="mb_15">Our store has re-opened for shopping, </p>
                            <p>exchange Every day 11am to 7pm</p>
                        </div>
                        <div class="mb_30">
                            <ul class="tf-social-icon d-flex gap-15 style-default">
                                <li><a href="#" class="box-icon link round social-facebook border-line-black"><i class="icon fs-16 icon-fb"></i></a></li>
                                <li><a href="#" class="box-icon link round social-twiter border-line-black"><i class="icon fs-16 icon-Icon-x"></i></a></li>
                                <li><a href="#" class="box-icon link round social-instagram border-line-black"><i class="icon fs-16 icon-instagram"></i></a></li>
                                <li><a href="#" class="box-icon link round social-tiktok border-line-black"><i class="icon fs-16 icon-tiktok"></i></a></li>
                                <li><a href="#" class="box-icon link round social-pinterest border-line-black"><i class="icon fs-16 icon-pinterest-1"></i></a></li>
                            </ul>
                        </div>
                        <div>
                        <Link to="/storelocation" class="tf-btn btn-outline-dark radius-3">Get Directions<i class="icon icon-arrow-right"></i></Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="flat-spacing-10">
            <div class="container">
                <div class="tf-grid-layout md-col-2">
                    <div class="tf-ourstore-content pl-124">
                        <h5 class="mb_24">Ecomus London</h5>
                        <div class="mb_20">
                            <p class="mb_15"><strong>Address</strong></p>
                            <p>66 Mott St, New York, New York, Zip Code: 10006, AS</p>
                        </div>
                        <div class="mb_20">
                            <p class="mb_15"><strong>Phone</strong></p>
                            <p>(623) 934-2400</p>
                        </div>
                        <div class="mb_20">
                            <p class="mb_15"><strong>Email</strong></p>
                            <p>EComposer@example.com</p>
                        </div>
                        <div class="mb_36">
                            <p class="mb_15"><strong>Open Time</strong></p>
                            <p class="mb_15">Our store has re-opened for shopping, </p>
                            <p>exchange Every day 11am to 7pm</p>
                        </div>
                        <div class="mb_30">
                            <ul class="tf-social-icon d-flex gap-15 style-default">
                                <li><a href="#" class="box-icon link round social-facebook border-line-black"><i class="icon fs-16 icon-fb"></i></a></li>
                                <li><a href="#" class="box-icon link round social-twiter border-line-black"><i class="icon fs-16 icon-Icon-x"></i></a></li>
                                <li><a href="#" class="box-icon link round social-instagram border-line-black"><i class="icon fs-16 icon-instagram"></i></a></li>
                                <li><a href="#" class="box-icon link round social-tiktok border-line-black"><i class="icon fs-16 icon-tiktok"></i></a></li>
                                <li><a href="#" class="box-icon link round social-pinterest border-line-black"><i class="icon fs-16 icon-pinterest-1"></i></a></li>
                            </ul>
                        </div>
                        <div>
                        <Link to="/storelocation" class="tf-btn btn-outline-dark radius-3">Get Directions<i class="icon icon-arrow-right"></i></Link>
                        </div>
                    </div>
                    <div class="tf-ourstore-img">
                        <img class="lazyload" data-src="/assets/images/shop/store/ourstore4.png" src="/assets/images/shop/store/ourstore4.png" alt="our-store"/>
                    </div>
                </div>
            </div>
        </section>
        <section class="flat-spacing-15">
            <div class="container">
                <div class="tf-grid-layout md-col-2">
                    <div class="tf-ourstore-img">
                        <img class="lazyload" data-src="/assets/images/shop/store/ourstore3.png" src="/assets/images/shop/store/ourstore3.png" alt="our-store"/>
                    </div>
                    <div class="tf-ourstore-content">
                        <h5 class="mb_24">Ecomus Dubai</h5>
                        <div class="mb_20">
                            <p class="mb_15"><strong>Address</strong></p>
                            <p>66 Mott St, New York, New York, Zip Code: 10006, AS</p>
                        </div>
                        <div class="mb_20">
                            <p class="mb_15"><strong>Phone</strong></p>
                            <p>(623) 934-2400</p>
                        </div>
                        <div class="mb_20">
                            <p class="mb_15"><strong>Email</strong></p>
                            <p>EComposer@example.com</p>
                        </div>
                        <div class="mb_36">
                            <p class="mb_15"><strong>Open Time</strong></p>
                            <p class="mb_15">Our store has re-opened for shopping, </p>
                            <p>exchange Every day 11am to 7pm</p>
                        </div>
                        <div class="mb_30">
                            <ul class="tf-social-icon d-flex gap-15 style-default">
                                <li><a href="#" class="box-icon link round social-facebook border-line-black"><i class="icon fs-16 icon-fb"></i></a></li>
                                <li><a href="#" class="box-icon link round social-twiter border-line-black"><i class="icon fs-16 icon-Icon-x"></i></a></li>
                                <li><a href="#" class="box-icon link round social-instagram border-line-black"><i class="icon fs-16 icon-instagram"></i></a></li>
                                <li><a href="#" class="box-icon link round social-tiktok border-line-black"><i class="icon fs-16 icon-tiktok"></i></a></li>
                                <li><a href="#" class="box-icon link round social-pinterest border-line-black"><i class="icon fs-16 icon-pinterest-1"></i></a></li>
                            </ul>
                        </div>
                        <div>
                        <Link to="/storelocation" class="tf-btn btn-outline-dark radius-3">Get Directions<i class="icon icon-arrow-right"></i></Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* <!-- /Our Store --> */}

        </>
    )
}
export default OurStoreDetails;